import { render, staticRenderFns } from "./MarketingTasks.vue?vue&type=template&id=d77e8caa"
import script from "./MarketingTasks.vue?vue&type=script&lang=js"
export * from "./MarketingTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports